import { useShowLoadingToast } from '@/routes/-hooks/useShowLoadingToast';
import { useLeaveBlocker } from '@/routes/_embaUserLayout/-hooks/useLeaveBlocker';
import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';

export const useEvaluationPolling = (
  isEvaluated: boolean,
  startPolling: (interval: number) => void,
  stopPolling: () => void,
) => {
  const prevIsEvaluatedRef = useRef(isEvaluated);
  const loadingToastIdRef = useRef<string | null>(null);

  const {
    unBlocking: unBlockingLeave,
    onBlocking,
    initBlocking,
  } = useLeaveBlocker();
  initBlocking();

  useEffect(() => {
    if (!isEvaluated) {
      onBlocking();
      loadingToastIdRef.current = useShowLoadingToast({
        message: '評価の生成中...（平均1〜2分ほどかかります）',
      });
      startPolling(3000); // 3秒ごとにポーリング
    } else if (prevIsEvaluatedRef.current === false && isEvaluated === true) {
      // 評価が完了した瞬間（isEvaluatedが false → true の変化時）のみ実行
      // ページリロード時は初回からprevIsEvaluatedRef.currentが true のため、この条件には入らない
      stopPolling();
      if (loadingToastIdRef.current) {
        toast.dismiss(loadingToastIdRef.current);
      }
      toast.success('評価の生成が完了しました');
      unBlockingLeave();
    } else {
      // 初期状態で評価が完了している場合は離脱防止を解除
      unBlockingLeave();
    }

    prevIsEvaluatedRef.current = isEvaluated;

    return () => {
      stopPolling();
      if (loadingToastIdRef.current) {
        toast.dismiss(loadingToastIdRef.current);
      }
    };
  }, [isEvaluated, startPolling, stopPolling, unBlockingLeave, onBlocking]);
};
